import React from "react";

const AlertModal = ({ isOpen, title = "Notice", message, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black-0 bg-opacity-20">
      {/* <div className="absolute inset-0 bg-black/40" onClick={onClose} /> */}

      <div className=" shadow-xl z-10 w-[520px] rounded-2xl bg-white px-6 pb-6 pt-3">
        <div className=" mb-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h2 className="text-2xl text-gray-900 font-semibold">{title}</h2>
          </div>
          <button onClick={onClose} className=" text-ft20-28  text-black-0">
            ✕
          </button>
        </div>

        <div className="text-gray-600 mb-6 space-y-4 font-InterRegular text-ft14-17">
          {message}
        </div>

        <button
          onClick={onClose}
          className="w-full rounded-xl bg-[#0B1B3F] py-3 text-ft14-17 font-medium text-white transition hover:opacity-90"
        >
          I Understand
        </button>
      </div>
    </div>
  );
};

export default AlertModal;
